import { useMemo, useState } from 'react';
import { Table } from 'tea-component';
import { useMemoizedFn } from 'ahooks';

import type { SortBy } from 'tea-component/lib/table/addons';

const { sortable } = Table.addons;

export default function useTableSort(records?: IStudioManagementKeyIssue[]) {
  const [sortInfos, setSortInfos] = useState<SortBy<any>[]>([]);

  const sortedRecords = useMemo<IStudioManagementKeyIssue[]>(() => {
    if (!Array.isArray(records)) return [];
    if (!sortInfos?.length) return records;
    // 取消排序时需要恢复默认顺序，这里需要保留原始records的顺序，所以sort方法不能直接在records上调用
    return [...records]?.sort(sortable.comparer(sortInfos));
  }, [sortInfos, records]);

  const handleSortChange = useMemoizedFn((value) => {
    const newSortInfos = value?.[0] ? [value?.[0]] : [];
    setSortInfos(newSortInfos);
  });

  return {
    sortInfos,
    handleSortChange,
    sortedRecords,
  };
}
